import { triggerEmarsysEvent } from '../emarsys/triggerEmarsysEvent';

export const dispatchTestMode = (storeKey: string, nodeEnvironment: string): void => {
    if (!storeKey.endsWith('production') || nodeEnvironment === 'development') {
        triggerEmarsysEvent({ command: 'testMode' });
    }
};